export default __webpack_public_path__ + "static/media/offBoarding.8f47bb9c.png";